import { en } from './en';

export const ja = {
  ...en,
  home: 'ホーム',
  reports: 'レポート',
  scans: 'スキャン',
  settings: '設定',
  profile: 'プロフィール',
  login: 'ログイン',
  signup: '新規登録',
  register: '登録',
  logout: 'ログアウト',
  upgrade: 'アップグレード',
  notifications: '通知',
  language: '言語',
  englishShort: 'EN',
  japanese: '日本語',
  japaneseNative: '日本語',
  toggleNavigationMenu: 'ナビゲーションメニューを切り替え',
  switchToJapanese: '日本語に切り替え',
  switchToEnglish: '英語に切り替え',
  fortexaLogoAlt: 'FORTEXA ロゴ',
  field: '項目',
  page: 'ページ',
  show: '表示',
  hide: '非表示',
  analyzing: '分析中...',
  securityDisclaimer: '認証情報は保存されず、スキャン中のみメモリ上で安全に処理されます',
  configureScan: 'スキャンを設定',
  enterCredentials: '認証情報の入力',
  verifyConfiguration: '設定を確認',
  detectedLoginForm: '検出されたログインフォーム',
  availableFields: '利用可能な項目:',
  submitButton: '送信ボタン',
  tip: 'ヒント:',
  loginSuccessful: 'ログインに成功しました！',
  credentialsVerified: '認証情報を確認しました。セッションCookieを取得しました。',
  loginFailed: 'ログインに失敗しました',
  couldNotAuthenticateProvidedCredentials: '入力された認証情報では認証できませんでした',
  loginFieldNotFound: 'ページ上でログイン項目が見つかりませんでした。ログインフォームを再検出してください。',
  loginFieldFillFailed: 'ログイン項目の入力に失敗しました。ログインフォームを再検出してください。',
  loginAnalysisFailed: 'ページの内容から、ログインに失敗したと判断されました。',
  loginUnexpectedError: 'ログインのテスト中に予期しないエラーが発生しました。',
  loginPanelNotFound: 'このページでログインフォームを開けませんでした。URLをご確認のうえ、再度お試しください。',
  loginSubmitNoEffect: 'ログインフォームを送信しても変化がありませんでした。上の送信ボタンを別のものに変更してお試しください。',
  loginAuthUnconfirmed: 'ログイン状態を確認できませんでした。',
  loginNoSessionCookies: 'このサイトはスキャンで再利用できる形式でログイン状態を保持していないため、認証付きスキャンには対応できません。',
  loginUnconfirmed: 'ログイン状態を確認できません',
  loginUnconfirmedExplain: '認証情報は送信されましたが、サイト側でログイン状態として扱われたかを確認できませんでした。このまま続行できますが、結果は公開ページのみを対象とする可能性があります。',
  continueAnyway: 'このまま続行',
  signedInMarkerLabel: 'ログイン時のみ表示される文字列（任意）',
  signedInMarkerPlaceholder: '例: ログアウト',
  signedInMarkerHint: 'ログイン後にのみサイト上に表示される語句をご入力ください。スキャンがログイン後のページに到達しているかの確認に使用します。',
  authCoverageConfirmed: 'このスキャンではログイン状態を確認しました。',
  authCoverageUnconfirmed: 'ログイン状態を確認できませんでした。結果は公開ページのみを対象とする可能性があります。',
  authenticationVerified: '認証を確認しました',
  readyToStartAuthenticatedSecurityScan: '認証付きセキュリティスキャンを開始できます',
  targetLabel: '対象:',
  loginUrlLabel: 'ログインURL:',
  fieldsLabel: '項目数:',
  credentialFields: '件の認証情報項目',
  enter: '入力',
  selectFieldOption: '--- {label} を選択 ---',
  targetUrlHelp: '脆弱性を分析したい主対象のURLです',
  loginPageUrlHelp: 'ログインページのURLです（対象URLと同じでもかまいません）',
  detectionErrorLabel: '検出エラー:',
  enterTargetAndLoginUrls: 'スキャン対象のURLとログインページのURLを入力してください',
  authScanNoteTitle: '開始前にご確認ください — 制限事項',
  authScanNoteCaptcha: 'reCAPTCHA / CAPTCHA：ログインページにCAPTCHA認証が必要な場合、自動ログインは失敗します。スキャン前にCAPTCHAを一時的に無効化するか、CAPTCHAが適用されないテスト環境をご利用ください。',
  authScanNoteMFA: '二要素認証（2FA / MFA）：パスワード入力後にワンタイムコード（SMS・メール・認証アプリ）の入力が求められる場合、ツールはログインを完了できません。2FAを無効化したテスト用アカウントをご使用ください。',
  authScanNoteOAuth: 'ソーシャル / SSOログイン（Google、Microsoftなど）：標準的なユーザー名とパスワードのフォームログインのみ対応しています。「Googleでサインイン」などのボタンのみ提供されている場合、認証スキャンは利用できません。',
  authScanNoteWAF: 'IPブロック / ボット検知：一部のセキュリティシステムは自動リクエストをブロックする場合があります。スキャンが予期せず失敗する場合は、スキャンサーバーのIPアドレスを対象環境のホワイトリストに登録する必要があるかご確認ください。',
  scanComplete: 'スキャン完了',
  scanningInProgress: 'スキャン実行中',
  securityScanCompletedReviewBelow: 'セキュリティスキャンが完了しました。下記の結果をご確認ください。',
  runningAuthenticatedWebsiteScan: '認証済みWebサイトに対してすべてのセキュリティスキャナーを実行しています',
  finalizingResults: '結果を仕上げています...',
  // Engine-agnostic scan progress (see frontend/src/utils/scanStatus.js).
  scanStepInProgress: 'ステップ {current}/{total} を実行中...',
  scanningTarget: '{target} をスキャンしています...',
  vulnerabilityScan: '脆弱性スキャン',
  vulnerabilityScanAuth: '脆弱性スキャン（認証済み）',
  threatIntelligence: '脅威インテリジェンス',
  vulnerableHigh: '脆弱性あり（高）',
  vulnerableMedium: '脆弱性あり（中）',
  vulnerableLow: '脆弱性あり（低）',
  runningSecurityTests: '包括的なセキュリティテストを実行しています...',
  pageWillUpdateAutomatically: 'スキャンが完了すると、このページは自動的に更新されます。',
  urlsAndAlertsFound: '{urls} 件のURLを検出 - 現時点で {alerts} 件の警告',
  translatingReportToJapanese: 'レポートを日本語に翻訳しています...',
  savingSchedule: '予約を保存しています...',
  scheduleCreatedSuccessfully: '予約を作成しました。',
  analysisComplete: '分析完了！',
  scanWasStopped: 'スキャンは停止されました',
  stoppingScan: 'スキャンを停止しています...',
  stoppingScanAndRestartingContainers: 'スキャンを停止し、コンテナを再起動しています...',
  scanStoppedContainersRestartingForFreshEnvironment: 'スキャンを停止しました。新しい環境のためコンテナを再起動しています',
  stopRequestSent: '停止リクエストを送信しました...',
  failedToStopScanWithReason: 'スキャンの停止に失敗しました: {reason}',
  scanRequestAccepted: 'スキャン要求を受け付けました...',
  initializingScan: 'スキャンを初期化しています...',
  analyzingTargetEnvironment: '対象環境を分析しています...',
  performingComprehensiveSiteAnalysis: '包括的なサイト分析を実行しています...',
  aiGeneratedAnalysisSummary: 'AI生成の分析サマリー',
  generatingAiAnalysisWaitingForAllScanData: 'AI分析を生成しています...（すべてのスキャンデータを待機中）',
  uploadProgress: 'アップロード中 {progress}%',
  scanning: 'スキャン中...',
  pending: '保留',
  valid: '有効',
  unavailable: '利用不可',
  headersPresent: 'ヘッダー有無',
  technologiesDetected: '検出された技術',
  noTechnologiesDetected: '技術は検出されませんでした',
  scanFailed: 'スキャン失敗',
  passed: '合格',
  starting: '開始中',
  notSet: '未設定',
  securityHeaders: 'セキュリティヘッダー',
  performance: 'パフォーマンス',
  outOf100: '100点満点',
  securityConfig: 'セキュリティ設定',
  malicious: '悪意あり',
  threatScore: '脅威スコア',
  sslCertificate: 'SSL証明書',
  unknownIssuer: '不明な発行元',
  techStack: '技術スタック',
  wafStatus: 'WAFステータス',
  scoreOf100: 'スコア: {score}/100',
  optimizationScore: '最適化スコア',
  mxRecordsFound: 'MXレコードを検出',
  noMailServer: 'メールサーバーなし',
  domainRegistered: 'ドメイン登録済み',
  enabled: '有効',
  disabled: '無効',
  preloaded: 'プリロード済み',
  notPreloaded: '未プリロード',
  clean: '正常',
  foundCount: '{count} 件検出',
  listsChecked: '{count} 件のリストを確認',
  green: 'グリーン',
  hosting: 'ホスティング',
  notArchived: 'アーカイブなし',
  historicalSnapshots: '過去のスナップショット',
  timeout: 'タイムアウト',
  notFound: '見つかりません',
  urlsInSitemap: 'サイトマップ内のURL',
  complete: '完全',
  partial: '一部',
  missing: '未設定',
  linksFound: 'リンクを検出',
  redirectHops: 'リダイレクト数',
  serversFound: 'サーバーを検出',
  dnssecStatus: 'DNSSECステータス',
  securityPolicy: 'セキュリティポリシー',
  redirectTo: 'リダイレクト先:',
  tryDifferentSubmitButton: 'ログインに失敗した場合は、上のドロップダウンから別の送信ボタンを選んで再度お試しください。',
  selectLoginFieldsAndEnterCredentials: 'ログイン項目を選択し、認証情報を入力してください',
  reviewConfigurationAndStartAuthenticatedSecurityScan: '設定内容を確認し、認証付きセキュリティスキャンを開始してください',
  publicWebsiteScan: '公開Webサイトスキャン',
  authenticatedWebsiteScan: '認証付きWebサイトスキャン',
  chooseScanTypePrefix: 'スキャン種別を',
  chooseScanTypeHighlight: '選択',
  chooseScanTypeSubtitle: '実行するセキュリティスキャンの種類を選択してください',
  publicScanDescription: '公開されているWebサイト向けの包括的なセキュリティ分析です。詳細な脆弱性スキャン、パフォーマンス最適化チェック、セキュリティメタデータ分析を含みます。',
  authScanDescription: 'ログインで保護された領域向けの詳細なセキュリティ分析です。ログイン画面を自動検出し、認証情報を検証したうえで、認証済み領域を詳細にスキャンします。',
  comprehensiveVulnerabilityScan: '包括的な脆弱性スキャン',
  sitePerformanceAnalysis: 'サイトパフォーマンス分析',
  securityHeaderAnalysis: 'セキュリティヘッダー分析',
  websiteHealthCheck: 'Webサイト健全性チェック',
  noLoginRequired: 'ログイン不要',
  autoDetectLoginForms: 'ログインフォームの自動検出',
  credentialValidation: '認証情報の検証',
  inDepthAuthenticatedScan: '認証済み領域の詳細スキャン',
  cookieSessionManagement: 'Cookieベースのセッション管理',
  serverSideCredentialHandling: 'サーバー側での認証情報処理',
  scheduleScan: 'スキャンを予約',
  startPublicScan: '公開スキャンを開始',
  startAuthenticatedScan: '認証付きスキャンを開始',
  credentialsSecurityNote: '認証情報は保存されず、スキャン中のみメモリ上で安全に処理されます',
  heroTitle: 'ウェブサイト・ウェブアプリケーションのセキュリティリスクを可視化',
  scanNotice: 'スキャンはバックグラウンドで実行中です。完了時に通知します。このタブを閉じても、ページを更新しても、デバイスの電源を切っても問題ありません。',
  enterUrlToStart: '開始するURLを入力',
  urlExample: 'https://example.com',
  analyzeUrl: 'URLを分析',
  stopScan: 'スキャン停止',
  resumingScan: 'スキャンを再開しています...',
  saveScheduledScan: '予約スキャンを保存',
  schedulingModeActive: '予約設定モードが有効です',
  settingUpPublicScan: '{date} {time} の公開スキャンを設定しています',
  settingUpAuthScan: '{date} {time} の認証付きスキャンを設定しています',
  combinedScanReport: '統合スキャンレポート',
  combinedScanReportTarget: '：{target}',
  websiteScreenshot: 'Webサイトのスクリーンショット',
  backToProfile: 'プロフィールに戻る',
  historicalScan: '過去のスキャン',
  scannedOn: 'スキャン日時',
  loadingProfile: 'プロフィールを読み込んでいます...',
  sessionExpiredLoginAgain: 'セッションの有効期限が切れました。再度ログインしてください。',
  failedFetchProfile: 'プロフィールの取得に失敗しました',
  failedLoadProfile: 'プロフィールを読み込めませんでした。詳細はコンソールを確認してください。',
  failedUpdateProfile: 'プロフィールの更新に失敗しました',
  profileUpdated: 'プロフィールを更新しました。',
  myProfile: 'マイプロフィール',
  accountInformation: 'アカウント情報',
  editProfile: 'プロフィール編集',
  save: '保存',
  cancel: 'キャンセル',
  name: '名前',
  email: 'メールアドレス',
  password: 'パスワード',
  bio: '自己紹介',
  accountType: 'アカウント種別',
  memberSince: '登録日',
  lastLogin: '最終ログイン',
  noBioAdded: '自己紹介はまだ追加されていません',
  bioPlaceholder: '自己紹介を入力してください（最大500文字）',
  statistics: '統計',
  totalScans: '総スキャン数',
  noPlanScanLimit: 'プランなし',
  planScanLimitLabel: 'プランのスキャン上限',
  extraScansRemainingLabel: '追加スキャン残数',
  extraScansExpireOn: '有効期限: {date}',
  topUpSectionTitle: 'スキャン回数を追加しますか？',
  topUpSectionDescription: '月間のスキャン上限を使い切った場合は、現在のプランに単発スキャンを追加できます。追加スキャンは、月間の上限を使い切った後にのみ消費されます。',
  planLimitExhaustedHint: '今月のプラン内スキャンをすべて使用しました。引き続きスキャンするには、以下から追加スキャンをご購入ください。',
  buyExtraScans: '追加スキャンを購入',
  recentScans: '最近のスキャン',
  noScansYet: 'スキャンはまだありません。URLの分析から始めましょう。',
  scheduledScan: '予約スキャン',
  clickViewScanResults: 'クリックしてスキャン結果を表示（ステータス: {status}）',
  choosePlan: 'プランを選択',
  selectPlan: 'プランを選択',
  startingCheckout: '決済ページに移動中...',
  checkoutFailed: '決済の開始に失敗しました。もう一度お試しください。',
  billingUnavailable: '現在お支払いをご利用いただけません。しばらくしてから再度お試しいただくか、サポートまでお問い合わせください。',
  paymentProcessing: 'お支払いを確認しました。プランを有効化しています...',
  checkingPlanStatus: 'プラン状態を確認中...',
  refreshPlanStatus: '状態を更新',
  paymentPendingActivation: '決済は完了しましたが、有効化の同期中です。少し待ってから再読み込みしてください。',
  paymentSuccess: 'お支払いが完了しました！プランが有効になりました。',
  paymentCancelled: '決済がキャンセルされました。請求は発生していません。',
  currentPlanTitle: '現在のプラン',
  planStatus: 'ステータス',
  planStatusActive: '有効',
  planStatusPastDue: '支払い遅延',
  scansUsedLabel: '今月のスキャン使用数',
  seatsUsedLabel: '使用中のシート',
  teamManagement: 'チーム管理',
  emailAddress: 'メールアドレス',
  sendInvite: '招待を送信',
  activeMembers: 'アクティブメンバー',
  pendingInvites: '保留中の招待',
  revoke: '取り消す',
  revokeInvite: '招待を取り消す',
  inviteSentSuccess: '{email} に招待を送信しました',
  inviteEmailFailed: '招待は作成されましたが、メールを送信できませんでした。次のリンクを手動で共有してください: {link}',
  inviteRevokeFailed: '招待の取り消しに失敗しました',
  oneTimeScansRemaining: '残りスキャン数',
  planExpiresLabel: 'プラン有効期限',
  cancelSubscriptionNote: 'プランは現在の請求期間終了まで引き続き有効です。',
  subscriptionCancelled: 'サブスクリプションを解約しました。現在の請求期間終了まで利用できます。',
  cancelProSubscription: 'サブスクリプションを解約',
  downgradeConfirmMessage: 'サブスクリプションを解約しますか？現在の請求期間終了までご利用いただけます。',
  cancelSubscription: 'サブスクリプションを解約',
  keepPro: 'プランを継続',
  billingMonthly: '月払い',
  billingAnnual: '年払い',
  billingOneTime: '単発お試し',
  discount17Percent: '17％割引',
  mostPopular: '一番人気',
  planFree: 'フリープラン',
  planLight: 'ライトプラン',
  planBasic: 'ベーシックプラン',
  planPro: 'プロプラン',
  planTrial1: 'トライアル1',
  planTrial2: 'トライアル2',
  periodMonth: '/月',
  periodYear: '/年',
  priceExcludingTax: '税抜価格',
  priceIncludingTaxAmount: '税込価格: {amount}',
  planAccounts: '{count}アカウント',
  planScansPerMonth: '月{count}回スキャン',
  planScansForTarget: '1ターゲットにつき{count}回スキャン',
  trial1ScansAndDevice: '1デバイス / 1回スキャン',
  trial2ScansAndDevice: '1デバイス / 2回スキャン',
  validityPeriod: '有効期間: 90日間',
  severityAllLevels: 'すべての重大度レベル',
  severityCriticalHighOnly: '高・中のみ',
  failedCancelSubscription: 'サブスクリプションの解約に失敗しました',
  failedSendInvite: '招待の送信に失敗しました',
  loginTitle: 'ログイン',
  loggingIn: 'ログイン中...',
  loginWithGoogle: 'Googleでログイン',
  googleLoginSuccessful: 'Googleログインに成功しました。リダイレクトしています...',
  googleLoginFailed: 'Googleログインに失敗しました。もう一度お試しください。',
  googleLoginFailedShort: 'Googleログインに失敗しました',
  inviteEmailMismatch: 'この招待は別のメールアドレス宛に送信されています。招待されたGoogleアカウントまたは招待されたメールアドレスでサインインしてください。',
  loginFailedLater: 'ログインに失敗しました。しばらくしてからもう一度お試しください。',
  newUser: '初めてご利用ですか？',
  registerNow: '今すぐ登録',
  forgotPassword: 'パスワードをお忘れですか？',
  registerTitle: '登録',
  registering: '登録中...',
  signUpWithGoogle: 'Googleで登録',
  googleSignupSuccessful: 'Google登録に成功しました。リダイレクトしています...',
  googleSignupFailed: 'Google登録に失敗しました。もう一度お試しください。',
  googleSignupFailedShort: 'Google登録に失敗しました',
  registrationFailedLater: '登録に失敗しました。しばらくしてからもう一度お試しください。',
  haveAccount: 'すでにアカウントをお持ちですか？',
  logIn: 'ログイン',
  or: 'または',
  forgotPasswordDescription: 'メールアドレスを入力してください。パスワード再設定用リンクをお送りします。',
  sending: '送信中...',
  sendResetLink: '再設定リンクを送信',
  rememberPassword: 'パスワードを思い出しましたか？',
  resetPassword: 'パスワードをリセット',
  resetPasswordDescription: '新しいパスワードを入力してください。',
  newPassword: '新しいパスワード',
  confirmNewPassword: '新しいパスワードを確認',
  resetting: 'リセット中...',
  invalidResetLink: '無効なリセットリンクです',
  passwordsDoNotMatch: 'パスワードが一致しません',
  passwordMinLength: 'パスワードは8文字以上で入力してください',
  genericErrorLater: 'エラーが発生しました。しばらくしてからもう一度お試しください。',
  verifyEmail: 'メールアドレスの確認',
  otpSentTo: '6桁のコードを送信しました:',
  enterOtp: '6桁のコードを入力',
  verifying: '確認中...',
  verify: '確認',
  resendCode: 'コードを再送信',
  otpVerificationSuccess: '認証に成功しました。ようこそ。',
  verificationFailed: '認証に失敗しました。もう一度お試しください。',
  otpSentSuccess: 'OTPを送信しました。メールをご確認ください。',
  resendOtpFailed: 'OTPの再送信に失敗しました。もう一度お試しください。',
  wrongEmail: 'メールアドレスが違いますか？',
  goBackToLogin: 'ログインに戻る',
  scheduledScans: '予約スキャン',
  failedFetchSchedules: '予約の取得に失敗しました',
  failedDeleteSchedule: '予約の削除に失敗しました',
  failedTriggerScan: 'スキャンの実行に失敗しました',
  scheduledScansSubtitle: '単発および定期的なセキュリティスキャンを管理します',
  newSchedule: '+ 新規予約',
  activeSchedules: '有効な予約',
  loadingSchedules: '予約を読み込んでいます...',
  noScheduledScans: '予約スキャンはありません',
  noScheduledScansDescription: '最初の予約スキャンを作成して、対象へのセキュリティテストを自動実行しましょう。',
  goDashboardSchedule: 'プロフィールで予約する',
  fetched: '取得済み',
  public: '公開',
  auth: '認証',
  recurring: '定期',
  oneTime: '単発',
  recurrence: '繰り返し',
  nextRun: '次回実行',
  lastRun: '前回実行',
  lastFailure: '前回の失敗: {reason}',
  runNow: '今すぐ実行',
  edit: '編集',
  delete: '削除',
  deleteSchedulePrompt: 'この予約を削除しますか？',
  yesDelete: 'はい、削除',
  scheduled: '予約済み',
  running: '実行中',
  completed: '完了',
  failed: '失敗',
  dayAtTime: '{days}日 {time}',
  notAvailable: '該当なし',
  scheduleAScan: 'スキャンを予約',
  editSchedule: '予約を編集',
  targetUrlReadOnly: '対象URL（読み取り専用）',
  scheduleMode: '予約モード',
  pickDateTime: '日時を選択',
  autoRepeat: '自動繰り返し',
  date: '日付',
  time: '時刻',
  selectDate: '日付を選択',
  today: '今日',
  selectedTime: '選択時刻: {time}',
  timezoneNote: '時刻は {timezone} のタイムゾーンです',
  frequency: '頻度',
  twiceMonthly: '月2回',
  custom: 'カスタム',
  monthly: '毎月',
  daysOfMonth: '毎月の日付',
  executionTime: '実行時刻',
  processing: '処理中...',
  updateSchedule: '予約を更新',
  continueToConfig: '設定へ進む',
  pleaseLoginSchedule: 'スキャンを予約するにはログインしてください',
  pleaseSelectDateTime: '日付と時刻を選択してください',
  invalidDateTime: '日付または時刻が無効です',
  scheduledTimeFuture: '予約時刻は現在より後に設定してください',
  scheduledTimeWithinMonth: '予約時刻は現在から1か月以内に設定してください',
  pleaseSelectDay: '少なくとも1日を選択してください',
  configSavedRedirecting: '設定を保存しました。リダイレクトしています...',
  scheduleUpdated: '予約を更新しました。',
  scanScheduledSuccess: 'スキャンを予約しました。',
  failedSaveSchedule: '予約の保存に失敗しました',
  errInvalidTimezone: 'お使いの端末のタイムゾーンを認識できませんでした。もう一度お試しください。',
  errNoUpcomingOccurrence: 'この繰り返し設定には次回の実行日がありません。別の日を選択してください。',
  targetUrl: '対象URL',
  dismiss: '閉じる',
  configure: '設定',
  credentials: '認証情報',
  verifyStep: '確認',
  results: '結果',
  targetWebsiteUrl: '対象WebサイトURL',
  loginPageUrl: 'ログインページURL',
  detectLoginFields: 'ログイン項目を検出',
  detecting: '検出中...',
  back: '戻る',
  continue: '続行',
  testLogin: 'ログインをテスト',
  testingLogin: 'ログインをテスト中...',
  pleaseFillCredentials: 'すべての認証情報項目を入力してください',
  couldNotAnalyzeLogin: 'ログインページを分析できませんでした',
  noLoginFormsDetected: 'このページでログインフォームを検出できませんでした。',
  loginTestFailed: 'ログインテストに失敗しました',
  sessionExpiredTestAgain: 'セッションの有効期限が切れました。ログインテストをやり直してください。',
  failedStartScan: 'スキャンの開始に失敗しました',
  severity: '深刻度',
  vulnerabilityAnalysisResults: '脆弱性分析結果',
  alertTypes: 'アラート種別',
  totalOccurrences: '総発生件数',
  jsonReport: 'JSONレポート',
  pdfReport: 'PDFレポート',
  downloading: 'ダウンロード中...',
  generatingLang: '{lang}を生成中...',
  englishPdf: '英語PDF',
  high: '高',
  medium: '中',
  low: '低',
  informational: '情報',
  occurrence: '件',
  occurrences: '件',
  description: '説明',
  solution: '対策',
  affectedUrls: '影響を受けるURL（{count}件表示{more}）',
  moreInFullReport: '、詳細は完全版レポートに記載',
  vulnerabilityAffectsUrls: 'この脆弱性は合計{count}件のURLに影響します。影響を受けるすべてのURLは完全版レポートで確認できます。',
  requestResponseEvidence: 'リクエスト / レスポンスの証跡',
  evidenceRequest: 'リクエスト',
  evidenceResponse: 'レスポンス',
  loadingEvidence: 'リクエスト/レスポンスデータを読み込み中…',
  noEvidenceCaptured: 'この項目の生のリクエスト/レスポンスは取得されていません。',
  showAllEvidence: 'すべての{count}件のリクエスト/レスポンスを表示',
  showLessEvidence: '表示を減らす',
  evidenceFullInJson: 'すべての発生箇所の完全なリクエスト/レスポンスはJSONレポートに含まれます。',
  noVulnerabilities: 'セキュリティ脆弱性は検出されませんでした。良好な状態です。',
  failedDownloadDetailedReport: '詳細レポートのダウンロードに失敗しました',
  failedDownloadPdfReport: 'PDFレポートのダウンロードに失敗しました: {message}',
  geminiKeyExhausted: 'AIサービスが一時的に利用できません。しばらくしてから再度お試しください。',
  englishPdfOnly: '英語PDFには英語のみを含める必要があります',
  // PDFダウンロードの結果 — バックエンドの英語エラー文字列ではなく、構造化された
  // フィールドから判定する。
  pdfRateLimited: 'リクエストが多すぎます。しばらくしてから再度お試しください。',
  pdfGenerationFailed: 'レポートを生成できませんでした。再度お試しください。',
  pdfGenerationTimedOut: 'レポートの生成に時間がかかっています。再度お試しください。',
  pdfJobExpired: 'このレポートは利用できなくなりました。再度生成してください。',
  pdfScanIncomplete: 'このスキャンには利用可能なレポートがまだありません。',
  // スキャン失敗時の状態
  scanFailedTitle: 'スキャンを完了できませんでした',
  scanFailedVulnerability: 'セキュリティ診断を完了できなかったため、レポートは作成されていません。このスキャンはプランの利用回数に加算されていません。再度実行してください。',
  scanFailedGeneric: 'このスキャンは正常に完了しませんでした。プランの利用回数には加算されていません。再度実行してください。',
  rescanNow: 'スキャンを再実行',
  scanRateLimited: '次のスキャンを開始するまで、しばらくお待ちください。',
  planLimitReached: 'プランの上限に達しました。プロフィールページからアップグレードしてください。',
  organizationRequired: 'スキャンを実行するには有効なプランが必要です。',
  pdfDownloadFailed: 'PDFのダウンロードに失敗しました',
  downloadScanReports: 'スキャンレポートをダウンロード',
  downloadCompleteSecurityResults: '完全なセキュリティスキャン結果を希望の形式でダウンロードできます',
  generating: '生成中...',
  downloadPdfReport: 'PDFレポートをダウンロード',
  englishVersion: '英語版',
  japaneseVersion: '日本語版',
  downloadJsonData: 'JSONデータをダウンロード',
  initializingEnglishPdf: '英語PDFを初期化しています...',
  initializingJapanesePdf: '日本語PDFを初期化しています...',
  formattingScanData: 'スキャンデータを整形しています...',
  formattingAiAnalysis: 'AI分析を整形しています...',
  renderingPdfDocument: 'PDF文書をレンダリングしています...',
  finalizing: '最終処理中...',
  translatingToJapanese: '日本語レポートを準備しています...',
  downloadComplete: 'ダウンロードが完了しました。',
  failedDownloadReportTryAgain: 'レポートのダウンロードに失敗しました。もう一度お試しください。',
  pdfProgressNote: 'PDF生成ではレポートを整形します。最大2分ほどかかる場合があります。',
  downloadNote: 'PDF: 日英バイリンガルのプロフェッショナルレポート | JSON: 分析用の生データ',
  viewSiteHealthAnalysis: 'サイト健全性分析を表示（{count}コンポーネントを分析済み）',
  viewUrlscanAnalysis: '脅威インテリジェンス分析を表示',
  urlscanSecurityVerdict: 'セキュリティ判定',
  urlscanOverall: '総合',
  urlscanThreatScore: '脅威スコア',
  urlscanUrlscanScore: 'レピュテーションスコア',
  urlscanEngineDetections: 'エンジン検出',
  urlscanCommunityScore: 'コミュニティスコア',
  urlscanMalicious: '悪意あり',
  urlscanClean: '安全',
  urlscanMaliciousCount: '{count}件の悪意ある検出',
  urlscanPageInformation: 'ページ情報',
  urlscanDomain: 'ドメイン',
  urlscanIpAddress: 'IPアドレス',
  urlscanCountry: '国',
  urlscanServer: 'サーバー',
  urlscanTlsIssuer: 'TLS発行者',
  urlscanTlsValidDays: 'TLS有効日数',
  urlscanNetworkStatistics: 'ネットワーク統計',
  urlscanHttpRequests: 'HTTPリクエスト数',
  urlscanUniqueIps: 'ユニークIP数',
  urlscanUniqueCountries: 'ユニーク国数',
  urlscanDataTransferred: '転送データ量',
  urlscanAllDataShown: 'このスキャンの脅威インテリジェンスおよびページ分析データはすべて上記に表示されています。',
  mozillaObservatorySecurityConfiguration: 'セキュリティ設定',
  obsSecurityGrade: 'セキュリティグレード',
  obsScore: 'スコア',
  obsTestsPassed: 'テスト合格',
  obsTestsFailed: 'テスト不合格',
  obsGradeA: '優れたセキュリティ設定',
  obsGradeB: '概ね良好 — 軽微な不備あり',
  obsGradeC: '中程度のリスク — 複数のヘッダーが未設定',
  obsGradeD: '不十分な設定 — 重大な脆弱性リスク',
  obsGradeF: '危機的 — ほぼすべてのセキュリティヘッダーが未設定',
  obsRecommendedFixes: '推奨セキュリティヘッダーの修正',
  obsCspDesc: 'クロスサイトスクリプティング（XSS）およびデータインジェクション攻撃を防止',
  obsHstsDesc: 'HTTPSを強制し、SSLストリッピング攻撃を防止',
  obsXctoDesc: 'ドライブバイダウンロードを可能にするMIMEタイプスニッフィングをブロック',
  obsXfoDesc: '信頼されていないオリジンからのフレーム化をブロックしてクリックジャッキングを防止',
  obsRpDesc: 'サードパーティサイトへのリファラーデータ漏洩を制限',
  obsPpDesc: 'ブラウザ機能（カメラ、マイク、位置情報）へのアクセスを制限',
  obsNoData: 'このURLのセキュリティヘッダー分析データはありません。',
  sslCertificateDetails: 'SSL証明書の詳細',
  subject: 'サブジェクト',
  issuer: '発行者',
  validFrom: '有効開始日',
  validTo: '有効期限',
  serial: 'シリアル',
  validation: '検証',
  dnsRecords: 'DNSレコード',
  mxRecords: 'MXレコード',
  txtRecords: 'TXTレコード',
  found: '件検出',
  technologyStack: '技術スタック',
  openPorts: '開放ポート',
  open: '開放',
  noOpenPorts: '一般的な開放ポートは検出されませんでした',
  closedFilteredPorts: '閉鎖/フィルタ済みポート（{count}）',
  cookies: 'Cookie',
  headerCookies: 'ヘッダーCookie',
  clientCookies: 'クライアントCookie',
  viewHeaderCookies: 'ヘッダーCookieを表示（{count}）',
  viewClientCookies: 'クライアントCookieを表示（{count}）',
  whoisInformation: 'WHOIS情報',
  registrar: 'レジストラ',
  created: '作成日',
  expires: '有効期限',
  updated: '更新日',
  nameservers: 'ネームサーバー',
  domainStatus: 'ドメインステータス',
  mailConfiguration: 'メール設定',
  mailServices: 'メールサービス',
  noneDetected: '検出なし',
  mailTxtRecords: 'メールTXTレコード（{count}）',
  tlsSecurityAnalysis: 'TLSセキュリティ分析',
  grade: 'グレード',
  score: 'スコア',
  host: 'ホスト',
  socialMediaTags: 'ソーシャルメディアタグ',
  twitterCard: 'Twitterカード',
  themeColor: 'テーマカラー',
  redirectChain: 'リダイレクトチェーン',
  webArchiveHistory: 'Webアーカイブ履歴',
  totalSnapshots: '総スナップショット数',
  available: '利用可能',
  firstSnapshot: '最初のスナップショット',
  lastSnapshot: '最後のスナップショット',
  carbonFootprint: 'カーボンフットプリント',
  greenHosting: 'グリーンホスティング',
  yes: 'はい',
  no: 'いいえ',
  co2PerVisit: '訪問あたりCO2',
  cleanerThan: 'よりクリーン',
  ofSites: 'のサイト',
  robotsTxt: 'Robots.txt',
  noRobotsTxt: 'robots.txtファイルは見つかりませんでした',
  sitemap: 'サイトマップ',
  noSitemap: 'サイトマップは見つかりませんでした',
  urls: 'URL',
  viewSitemaps: 'サイトマップを表示（{count}）',
  viewUrls: 'URLを表示（{count}）',
  dnsServer: 'DNSサーバー',
  server: 'サーバー',
  provider: 'プロバイダー',
  country: '国',
  status: 'ステータス',
  enabledValid: '有効かつ正常',
  notEnabled: '未有効',
  algorithm: 'アルゴリズム',
  keyTag: 'キータグ',
  digestType: 'ダイジェスト種別',
  dsRecords: 'DSレコード',
  dnskeyRecords: 'DNSKEYレコード',
  websiteRanking: 'Webサイトランキング',
  trafficRank: 'トラフィック順位',
  notGlobalTop1m: 'グローバルトップ100万ドメインリストには見つかりませんでした。',
  httpStatus: 'HTTPステータス',
  responseTime: '応答時間',
  traceRoute: 'トレースルート',
  allHopsUnreachable: '全{count}ホップに到達できませんでした（ファイアウォールまたはCDNによりブロックされている可能性があります）。',
  unreachableHopsHidden: '到達不能なホップ{count}件を非表示',
  traceRouteDataAvailable: 'トレースルートデータを利用できます',
  ipAddress: 'IPアドレス',
  ip: 'IP',
  version: 'バージョン',
  location: '所在地',
  isp: 'ISP',
  organization: '組織',
  firewall: 'ファイアウォール',
  tlsGrade: 'TLSグレード',
  quality: '品質',
  mailConfig: 'メール設定',
  securityBlacklist: 'セキュリティブラックリスト',
  carbon: 'カーボン',
  archives: 'アーカイブ',
  socialTags: 'ソーシャルタグ',
  links: 'リンク',
  redirects: 'リダイレクト',
  rank: 'ランク',
  alerts: 'アラート',
  alertsCount: '{count} アラート',
  alertsCountPartial: '{count} アラート（一部）',
  crawlerRules: 'クローラールール',
  globalRank: 'グローバルランク',
  qualityMetrics: '品質指標',
  overall: '全体',
  accessibility: 'アクセシビリティ',
  bestPractices: 'ベストプラクティス',
  loadingExperience: '読み込み体験',
  qualityDataAvailable: '品質データを利用できます',
  // WebCheck detail labels
  subjectAltNames: 'サブジェクト代替名（{count}）',
  sha256Label: 'SHA-256',
  httpHeaders: 'HTTPヘッダー',
  firewallWafDetection: 'ファイアウォール / WAF検出',
  wafDetected: 'WAF検出',
  notDetected: '未検出',
  wafNameLabel: '名称',
  confidence: '信頼度',
  hstsFullTitle: 'HSTS（HTTP Strict Transport Security）',
  maxAge: '最大有効期間',
  includeSubdomains: 'サブドメインを含む',
  seconds: '秒',
  days: '日',
  securityTxtTitle: 'Security.txt',
  noSecurityTxtFound: 'security.txtファイルは見つかりませんでした',
  contactLabel: '連絡先',
  languagesLabel: '言語',
  canonicalLabel: '正規URL',
  viewFullSecurityTxt: 'security.txtの全文を表示',
  blockLists: 'ブロックリスト',
  listedOnBlocklists: '{count}件のブロックリストに登録されています',
  notListedOnBlocklists: 'いずれのブロックリストにも登録されていません',
  cleanOnLists: '{count}件のリストでクリーン',
  blockListDataAvailable: 'ブロックリストデータが利用可能です',
  blockedLabel: 'ブロック済み',
  linkedPages: 'リンクページ',
  internalLinks: '内部リンク',
  externalLinks: '外部リンク',
  viewInternalLinks: '内部リンクを表示（{count}）',
  viewExternalLinks: '外部リンクを表示（{count}）',
  urlLabel: 'URL',
  dnsServerInfoAvailable: 'DNSサーバー情報が利用可能です',
  dnssecTitle: 'DNSSEC',
  hopLabel: 'ホップ',
  rttLabel: 'RTT',
  ogTitleLabel: 'OGタイトル',
  ogDescriptionLabel: 'OG説明文',
  ogImageLabel: 'OG画像',
  serverN: 'サーバー {n}',
  priorityLabel: '優先度',
  // ZapReportEnhanced labels
  translatingVulnerabilityData: '脆弱性データを日本語に翻訳中...',

  // ── Admin Dashboard ──────────────────────────────────────────────────────────
  adminPanel: '管理者パネル',
  adminDashboard: '管理ダッシュボード',
  adminUsers: 'ユーザー',
  adminOrganizations: '組織',
  adminScans: 'スキャン',
  adminSystemHealth: 'システム状態',
  adminOverview: '概要',
  adminTotalUsers: '総ユーザー数',
  adminVerifiedUsers: '認証済みユーザー',
  adminActiveOrgs: '有効な組織',
  adminTotalOrgs: '総組織数',
  adminRunningScans: '実行中のスキャン',
  adminTotalScans: '総スキャン数（全期間）',
  adminRecentUsers: '最近の登録',
  adminPlanDistribution: 'プラン別分布',
  adminSearch: '検索...',
  adminFilter: 'フィルター',
  adminName: '名前',
  adminEmail: 'メールアドレス',
  adminPlan: 'プラン',
  adminRole: '役割',
  adminJoined: '登録日',
  adminLastLogin: '最終ログイン',
  adminStatus: 'ステータス',
  adminOwner: 'オーナー',
  adminSeats: 'シート',
  adminUsage: '使用状況',
  adminSubscription: 'サブスクリプション',
  adminTarget: '対象URL',
  adminUser: 'ユーザー',
  adminStarted: '開始',
  adminDuration: '所要時間',
  adminOnline: 'オンライン',
  adminOffline: 'オフライン',
  adminConfigured: '設定済み',
  adminNotConfigured: '未設定',
  adminCollections: 'コレクション数：',
  adminStorage: 'ストレージ：',
  adminConnected: '接続済み',
  adminDisconnected: '切断',
  adminConnecting: '接続中',
  adminDisconnecting: '切断中',
  adminMs: 'ms',
  adminMB: 'MB',
  adminNoData: 'データがありません',
  adminLoading: '読み込み中...',
  adminFetchError: 'データの読み込みに失敗しました。もう一度お試しください。',
  adminFree: '無料',
  adminLight: 'ライト',
  adminBasic: 'ベーシック',
  adminPro: 'プロ',
  adminTrial1: 'トライアル1',
  adminTrial2: 'トライアル2',
  adminAllPlans: 'すべてのプラン',
  adminAllStatuses: 'すべてのステータス',
  adminActive: '有効',
  adminCanceled: 'キャンセル',
  adminPastDue: '支払い遅延',
  adminTrialing: 'トライアル中',
  adminQueuedStatus: '待機中',
  adminPendingStatus: '保留',
  adminCombiningStatus: '結合中',
  adminCompletedStatus: '完了',
  adminFailedStatus: '失敗',
  adminStoppedStatus: '停止',
  adminPrevious: '前へ',
  adminNext: '次へ',
  adminPaginationInfo: '{page} / {pages} ページ（全{total}件）',
  adminWaiting: '待機：',
  adminJobsActive: 'アクティブ：',
  adminJobsFailed: '失敗：',
  adminJobsCompleted: '完了：',
  adminRss: 'RSS',
  adminRetry: '再試行',
  adminRefresh: '更新',
  adminVerified: '認証済み',
  adminUnverified: '未認証',
  adminMember: 'メンバー',
  adminRoleAdmin: '管理者',
  adminRoleSuperadmin: 'スーパー管理者',
  adminUptimeFormat: '{h}時間{m}分{s}秒',
  adminDurationSeconds: '{s}秒',
  adminDurationMinutes: '{m}分{s}秒',
  adminLastUpdated: '最終更新：{time}',
  adminOnlineCount: '{online}/{total} オンライン',

  // ── Admin lifecycle actions ──────────────────────────────────────────────────
  adminActions: '操作',
  adminYou: 'あなた',
  adminDisabled: '無効化済み',
  adminEnable: '有効化',
  adminDisable: '無効化',
  adminMakeAdmin: '管理者にする',
  adminRemoveAdmin: '管理者を解除',
  adminRemoveFromOrg: '組織から削除',
  adminCancelSubscription: 'サブスクリプションをキャンセル',
  adminActionFailed: '操作に失敗しました。もう一度お試しください。',
  // ── 管理者エラーコード (pages/Admin/adminLabels.js で対応付け) ──────────────
  adminErrAccountDisabled: 'このアカウントは無効化されています。管理者にお問い合わせください。',
  adminErrUnauthorized: 'セッションの有効期限が切れました。再度ログインしてください。',
  adminErrForbidden: 'この操作を行う権限がありません。',
  adminErrServer: 'サーバー側で問題が発生しました。もう一度お試しください。',
  adminErrSuperadminRequired: '管理者アカウントを操作できるのはスーパー管理者のみです。',
  adminErrInvalidId: '対象のレコードを特定できませんでした。',
  adminErrUserNotFound: 'このユーザーは既に存在しません。',
  adminErrOrgNotFound: 'この組織は既に存在しません。',
  adminErrInvalidRole: 'その権限は有効ではありません。',
  adminErrInvalidPayload: 'リクエストが正しくありません。もう一度お試しください。',
  adminErrSelfRole: '自分自身の権限は変更できません。',
  adminErrSelfDisable: '自分自身のアカウントは無効化できません。',
  adminErrSelfDelete: '自分自身のアカウントは削除できません。',
  adminErrLastAdmin: '最後の管理者のため、削除・変更できません。',
  adminErrLastAdminOrg: 'この組織を無効化すると、最後の管理者がログインできなくなります。',
  // ── API エラー/ステータスコード (utils/apiErrors.js で対応付け) ────────────
  errUnexpected: '問題が発生しました。もう一度お試しください。',
  errSessionRevoked: 'パスワードが変更されたため、このセッションは終了しました。再度サインインしてください。',
  errAuthResetTokenInvalid: 'この再設定リンクは無効か、有効期限が切れています。もう一度お試しください。',
  errTooManyRequests: 'リクエストが多すぎます。数分待ってからもう一度お試しください。',
  errOrgCreating: '組織のセットアップ中です。少し待ってからもう一度お試しください。',
  errPlanCheckFailed: 'プランの利用状況を確認できませんでした。もう一度お試しください。',
  errInsufficientRole: 'プランの購入・変更ができるのは組織のオーナーまたは管理者のみです。',
  errAlreadySubscribed: '有効なサブスクリプションが既にあります。別のプランを購入するには先に解約してください。',
  errNetwork: '通信エラーが発生しました。接続を確認してもう一度お試しください。',
  errPasswordsMismatch: 'パスワードが一致しません。',
  joinWelcome: '{orgName} へようこそ！リダイレクトしています…',
  joinInviteInvalidTitle: '招待が無効です',
  joinGoHome: 'ホームへ戻る',
  errServer: 'サーバー側で問題が発生しました。もう一度お試しください。',
  errUnauthorized: 'セッションの有効期限が切れました。再度ログインしてください。',
  errForbidden: 'この操作を行う権限がありません。',
  errAccountDisabled: 'このアカウントは無効化されています。管理者にお問い合わせください。',
  errAuthNoToken: 'サインインを完了できませんでした。もう一度お試しください。',
  errAuthGoogleFailed: 'Google サインインに失敗しました。もう一度お試しください。',
  errAuthGoogleSuccess: 'Google でサインインしました。',
  errAuthNameRequired: 'お名前を入力してください。',
  errAuthEmailInvalid: '有効なメールアドレスを入力してください。',
  errAuthPasswordRequired: 'パスワードを入力してください。',
  errAuthPasswordTooShort: 'パスワードは8文字以上で入力してください。',
  errAuthUserExists: 'このメールアドレスのアカウントは既に存在します。',
  errAuthRegistered: 'アカウントを作成しました。',
  errAuthInvalidCredentials: 'メールアドレスまたはパスワードが正しくありません。',
  errAuthLoginSuccess: 'サインインしました。',
  errAuthOtpSent: '確認コードをメールで送信しました。',
  errAuthOtpFormat: '6桁の確認コードを入力してください。',
  errAuthOtpInvalid: 'この確認コードは無効か、有効期限が切れています。',
  errAuthResetEmailSent: 'そのメールアドレスが登録済みの場合、再設定用リンクを送信しました。',
  errAuthPasswordReset: 'パスワードを再設定しました。',
  errOrgNotFound: 'この組織は既に存在しません。',
  errOrgNoMembership: '組織に所属していません。',
  errOrgEmailRequired: 'メールアドレスを入力してください。',
  errOrgRoleInvalid: '有効な権限を選択してください。',
  errOrgInviteForbidden: 'メンバーを招待できるのはオーナーと管理者のみです。',
  errOrgInviteAdminForbidden: '管理者を招待できるのはオーナーのみです。',
  errOrgInviteCancelForbidden: '招待を取り消せるのはオーナーと管理者のみです。',
  errOrgInviteInvalid: 'この招待リンクは無効です。既に使用されている可能性があります。',
  errOrgInviteUsed: 'この招待は既に承認されています。',
  errOrgInviteExpired: 'この招待は有効期限が切れています。チーム管理者に新しい招待を依頼してください。',
  errOrgInviteNotFound: 'この招待は既に存在しません。',
  errOrgInviteInactive: 'この招待は既に有効ではありません。',
  errOrgInviteCancelled: '招待を取り消しました。',
  errOrgInviteTokenRequired: 'この招待リンクは不完全です。',
  errOrgInviteEmailMismatch: 'この招待は別のメールアドレス宛に送信されています。招待されたアドレスでサインインしてください。',
  errOrgSeatLimit: 'この組織には空きシートがありません。メンバーを追加するにはプランをアップグレードしてください。',
  errOrgAlreadyMember: '既にこの組織のメンバーです。',
  errOrgOtherOrgMember: '既に別の組織に所属しています。移行についてはサポートにお問い合わせください。',
  errOrgAccountExists: 'このメールアドレスのアカウントは既に存在します。サインインして招待を承認してください。',
  errOrgSignupFieldsRequired: 'アカウント作成にはお名前とパスワードが必要です。',
  // ── システムヘルスのサービス名 ────────────────────────────────────────────
  // 製品名は運用担当者向けのため、あえてそのまま表示します。
  adminHealthServer: 'Node.js サーバー',
  adminHealthMongodb: 'MongoDB',
  adminHealthRedis: 'Redis',
  adminHealthQueue: 'BullMQ キュー',
  adminHealthWebcheck: 'WebCheck',
  adminHealthZap: 'OWASP ZAP',
  adminHealthZapAuth: 'OWASP ZAP（認証スキャン）',
  adminHealthGemini: 'Gemini AI',
  adminHealthPagespeed: 'Google PageSpeed',
  adminHealthUrlscan: 'urlscan.io',
  adminHealthUnreachable: 'サービスに接続できません。詳細はブラウザのコンソールをご確認ください。',
  adminErrNoOrg: 'このユーザーは組織に所属していません。',
  adminErrOwnerProtected: '組織のオーナーを削除する代わりに、組織自体を削除してください。',
  adminErrNoSubscription: 'この組織には有効なサブスクリプションがありません。',

  adminUserDeleted: 'ユーザーを削除しました',
  adminUserUpdated: 'ユーザー情報を更新しました',
  adminUserRemovedFromOrg: 'ユーザーを組織から削除しました',
  adminOrgDeleted: '組織を削除しました',
  adminOrgUpdated: '組織情報を更新しました',
  adminSubscriptionCanceled: 'サブスクリプションは請求期間の終了時にキャンセルされます',

  adminDeleteUserTitle: 'ユーザーを削除',
  adminDeleteUserMessage: '{name}を完全に削除してもよろしいですか？この操作は取り消せません。',
  adminDeleteUserConfirm: 'ユーザーを削除',
  adminDisableUserTitle: 'ユーザーを無効化',
  adminDisableUserMessage: '{name}は直ちにログインできなくなります。このアカウントはいつでも再度有効化できます。',
  adminRemoveFromOrgTitle: '組織から削除',
  adminRemoveFromOrgMessage: '{name}を組織から削除し、単独アカウントにします。',
  adminGrantAdminTitle: '管理者権限を付与',
  adminGrantAdminMessage: '{name}にプラットフォーム管理者権限を付与しますか？管理ダッシュボード全体の閲覧・管理が可能になります。',
  adminRevokeAdminTitle: '管理者権限を削除',
  adminRevokeAdminMessage: '{name}のプラットフォーム管理者権限を削除しますか？管理ダッシュボードへのアクセスができなくなります。',

  adminDeleteOrgTitle: '組織を削除',
  adminDeleteOrgMessage: '{name}を完全に削除してもよろしいですか？メンバーは組織から削除され、有効なサブスクリプションはキャンセルされます。この操作は取り消せません。',
  adminDeleteOrgConfirm: '組織を削除',
  adminDisableOrgTitle: '組織を無効化',
  adminDisableOrgMessage: '{name}の全メンバーが直ちにログインできなくなります。この組織はいつでも再度有効化できます。',
  adminCancelSubscriptionTitle: 'サブスクリプションをキャンセル',
  adminCancelSubscriptionMessage: '{name}のサブスクリプションは現在の請求期間の終了時にキャンセルされます。それまではサービスを継続してご利用いただけます。',
  adminCancelSubscriptionConfirm: 'サブスクリプションをキャンセル',

  // ── Executive Analytics ───────────────────────────────────────────────────────
  adminAnalytics: '分析',
  adminEstimatedValue: '推定経常収益',
  adminEstimateBadge: '概算',
  adminEstimatedValueExplain: '各プランで有効なサブスクリプションを持つ組織数に、公開されている料金表の価格（月額換算）を掛けて算出した概算値です。現在のプラン割り当てに基づく見積りであり、割引・日割り計算・支払い失敗・返金は反映されません（データベースに記録されていないため）。',
  adminEstimatedValueTotal: '推定月次金額',
  adminEstimatedValueByPlan: 'プラン別推定金額',
  adminUserGrowth: '新規ユーザー登録数',
  adminUserGrowthExplain: '過去30日間に作成された新規ユーザーアカウント数の日次推移です（アカウント作成日に基づく）。',
  adminOrgGrowth: '新規組織登録数',
  adminOrgGrowthExplain: '過去30日間に作成された新規組織数の日次推移です（組織作成日に基づく）。',
  adminLast30Days: '過去30日間',
  adminNewInPeriod: 'この期間で新規{count}件',
  adminSubscriptionHealth: 'サブスクリプション状況',
  adminSubscriptionHealthExplain: '組織のサブスクリプションステータス別の現在の件数です。過去の状態変化を記録するログが存在しないため、これは履歴推移ではなく現時点のスナップショットです。',
  adminScanActivity: 'スキャンアクティビティ',
  adminScanActivityExplain: '直近7日間のスキャン件数のみを表示しています。スキャン記録は7日後に自動削除されるため、それ以上長い期間の推移は表示できません。',
  adminLast7Days: '過去7日間',
  adminScansThisWeek: 'この期間で{count}件のスキャン',
  adminTopOrgsByUsage: '利用状況上位の組織',
  adminTopOrgsByUsageExplain: '現在の請求サイクルにおける使用スキャン数で組織をランキングしています。',
  // ランディングページで再利用（旧・単独の /about ページ）
  aboutFeaturesTitle: '主な機能',
  aboutFeaturePerformanceTitle: 'パフォーマンス＆アクセシビリティ',
  aboutFeaturePerformanceDescription: 'ページ速度、アクセシビリティ、検索エンジン最適化のベストプラクティスに関するスコアを提供します。',
  aboutFeatureVulnerabilityTitle: '脆弱性スキャン',
  aboutFeatureVulnerabilityDescription: 'セキュリティ上の脆弱性を検出し、重大度と推奨される修正方法を提示します。',
  aboutFeatureInfraTitle: 'インフラストラクチャ調査',
  aboutFeatureInfraDescription: 'SSL/TLS設定、DNSレコード、Cookie、検出された技術スタックなどを詳しく分析します。',
  aboutFeatureAuthTitle: '認証付きスキャン',
  aboutFeatureAuthDescription: 'ログイン情報を安全に入力することで、ログイン後のページもスキャンできます。認証情報は保存されず、メモリ上でのみ処理されます。',
  aboutFeatureAiTitle: 'AIによる分析',
  aboutFeatureAiDescription: 'すべてのチェックが完了すると、セキュリティ状況をわかりやすい言葉で説明する要約が自動生成されます。',
  aboutFeatureReportsTitle: 'ダウンロード可能なレポート',
  aboutFeatureReportsDescription: '結果はバイリンガル対応のPDFレポート、または構造化されたJSON形式でダウンロードできます。',
  aboutFeatureOngoingTitle: 'チーム・組織のために',
  aboutFeatureOngoingDescription: 'ウェブサイトのセキュリティ状態を常に把握できます。会社アカウントを作成してチームを招待し、必要なときにいつでもスキャンを実行できます。',
  aboutHowItWorksTitle: 'ご利用の流れ',
  aboutStep1Title: 'URLを入力',
  aboutStep1Description: '評価したいウェブサイトを入力します。認証付きスキャンの場合はログイン情報も併せて入力できます。',
  aboutStep2Title: '自動解析の実行',
  aboutStep2Description: 'スキャンはバックグラウンドで進行するため、作業を続けながらお待ちいただけます。',
  aboutStep3Title: '結果の集約',
  aboutStep3Description: 'スコア、脆弱性の検出結果、インフラの詳細情報が一つの結果画面にまとめられます。',
  aboutStep4Title: 'AIによるレポート生成',
  aboutStep4Description: '検出内容とその重要性を、わかりやすい言葉でまとめた要約が生成されます。',
  aboutStep5Title: 'ダウンロードして活用',
  aboutStep5Description: 'レポートをPDFまたはJSON形式でダウンロードし、チームでの確認や開発者への引き継ぎに活用できます。',
  aboutReportsTitle: 'レポートと結果',
  aboutReportsBody: '各スキャンでは、スコアカード、詳細な脆弱性一覧、インフラ詳細レポート、ページのスクリーンショット、AIによる要約が生成されます。過去のスキャンは一定期間閲覧可能で、アカウントには全期間のスキャン累計数が記録されます。',
  aboutFormatPdfTitle: 'PDFレポート',
  aboutFormatPdfDescription: '英語・日本語の両方に対応し、スコアの要約、AIによる分析、契約プランに応じた脆弱性一覧を含みます。',
  aboutFormatJsonTitle: 'JSONエクスポート',
  aboutFormatJsonDescription: '完全な構造化スキャンデータをエクスポートでき、自社ツールへの取り込みや技術記録の保管に活用できます。',
  aboutPlansTitle: '料金プラン',
  aboutPlansSubtitle: '月額・年額から選べる3つのサブスクリプションプランに加え、1回限りのお試しプランをご用意しています。',
  aboutOrAnnual: '（年額 {amount}）',
  aboutTrialsTitle: '一回限りのお試しプラン',
  aboutPaymentsTitle: '安全な決済',
  aboutPaymentsBody: '決済処理は広く利用されている決済代行サービスのStripeが担当しており、FORTEXAがカード情報を取得・保存することはありません。サブスクリプション課金と一回限りの支払いの両方に対応しており、決済確認後はプランが自動的に有効化されます。表示価格は税抜きで、決済時に消費税10%が加算されます。',

  // マーケティングランディングページ（未ログイン時のみ "/" に表示）
  marketingHeroEyebrow: 'ウェブサイト セキュリティ診断',
  marketingHeroTitle: 'ウェブサイトの安全性を、正確に把握する。',
  marketingHeroSubtitle: 'FORTEXAはウェブサイトのセキュリティ・パフォーマンス・設定状況を一括で診断し、専門知識がなくても理解できるレポートにまとめます。今すぐ行動につながる、明確な結果をお届けします。',
  marketingValueTitle: 'FORTEXAが選ばれる理由',
  marketingAiTitle: 'AIによるセキュリティ分析',
  marketingAiLead: '複雑なセキュリティスキャン結果を、わかりやすく実行可能なセキュリティレポートに変換します。',
  marketingAiBody: 'AIがスキャン結果を分析し、専門的なセキュリティデータを、主要なリスク・要約・推奨対応を含むわかりやすいレポートへと変換します。',
  marketingAiPrivacyTitle: 'プライバシーに配慮した設計',
  marketingAiPrivacyIntro: 'セキュリティスキャンデータをAIが処理する前に、分析のために送信されるデータから識別情報を除去します。',
  marketingAiPrivacyItemTargetLead: '対象情報はサニタイズされます。',
  marketingAiPrivacyItemTargetRest: 'ウェブサイトのURL、ホスト名、IPアドレス、DNS情報、スキャン識別子は、AIによる主要な分析の前にマスキングされます。',
  marketingAiPrivacyItemUserLead: 'ユーザーの識別情報は保護されます。',
  marketingAiPrivacyItemUserRest: 'アカウント名やメールアドレスは、AI分析に使用されるデータから除去されます。',
  marketingAiPrivacyItemHeadersLead: 'HTTPヘッダー値はサニタイズされます。',
  marketingAiPrivacyItemHeadersRest: '識別につながる可能性のあるURL、ホスト名、IPアドレス、Cookie、リダイレクト情報は除去される一方、セキュリティ上有用なヘッダー情報は保持されます。',
  marketingAiPrivacyItemGuardrail: 'また、AIへの入力内容に対する情報漏えい検知の仕組みも備えています。',
  marketingFinalCtaTitle: 'セキュリティを明確に。AIの力で。',
  marketingFinalCtaSecondary: '今すぐ始める',
};

